import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
const styles = ["fontFamily", "fontFeatureSettings", "fontSize", "fontSizeAdjust",
    "fontStretch", "fontStyle", "fontVariant", "fontWeight", "letterSpacing",
    "textDecoration", "textIndent", "textDecoration", "textShadow", "textTransform",
    "textOverflow", "borderLeft", "borderRight", "paddingLeft", "paddingRight",
];
function copyStyles(source, target) {
    const cs = window.getComputedStyle(source);
    for (const style of styles) {
        target.style[style] = cs[style];
    }
}
export const AutoExpandInput = React.forwardRef((props, forwardRef) => {
    // return <AutoExpandInputLocal {...props} inputref={ref} />;
    const inputRef = React.useRef();
    const { minWidth, style, ...rest } = props;
    const { placeholder, value } = props;
    const setRef = React.useCallback((ref) => {
        inputRef.current = ref;
        if (forwardRef) {
            if (typeof forwardRef === "function")
                forwardRef(ref);
            else
                forwardRef.current = ref;
        }
    }, [forwardRef]);
    React.useLayoutEffect(() => {
        const extraWidth = 0;
        const input = inputRef.current;
        if (!input)
            return;
        const _sizer = document.createElement("span");
        _sizer.style.position = "absolute";
        _sizer.style.top = "-1000px";
        _sizer.style.whiteSpace = "pre";
        if (process.env.NODE_ENV === "development") {
            _sizer.style.backgroundColor = "yellow";
            _sizer.style.top = "300px";
            _sizer.style.left = "100px";
        }
        document.body.appendChild(_sizer);
        copyStyles(input, _sizer);
        _sizer.innerText = value || placeholder || "";
        const width = _sizer.getBoundingClientRect().width;
        const newWidth = Math.max(width + extraWidth, (minWidth || 0));
        input.style.width = `${newWidth}px`;
        document.body.removeChild(_sizer);
    }, [minWidth, placeholder, value]);
    // console.log("search-text", rest.value);
    return _jsx("input", { ref: setRef, ...rest, type: "text", style: style, spellCheck: false });
});
